import moment from 'moment';

import { normalizeRateValue } from './lifeRates';

const percent = (value) => value / 100;

const YEAR_WEEKS = 52;
const YEAR_MONTHS = 12;

const computeMemberRate = (member, selectedOffer, rateValue) => {
  const { plan_type, rate_basis, rate_per_unit, income_pct } = selectedOffer;

  const stdEarningsMonthly = (salary, ratePerUnit, rate) => {
    return (((salary / YEAR_WEEKS / ratePerUnit) * rate ?? 0) * YEAR_WEEKS) / YEAR_MONTHS;
  };

  const stdBenefitMonthly = (weeklyBenefit, ratePerUnit, rate) => {
    return (((weeklyBenefit / ratePerUnit) * rate ?? 0) * YEAR_WEEKS) / YEAR_MONTHS;
  };

  const ltdEarningsMonthly = (salary, ratePerUnit, rate) => {
    return (salary / YEAR_MONTHS / ratePerUnit) * rate ?? 0;
  };

  const ltdBenefitMonthly = (monthlyBenefit, ratePerUnit, rate) => {
    return (monthlyBenefit / ratePerUnit) * rate ?? 0;
  };

  const weeklyBenefit = (salary, incomePct) => {
    return (salary * percent(incomePct)) / YEAR_WEEKS;
  };

  const monthlyBenefit = (salary, incomePct) => {
    return (salary * percent(incomePct)) / YEAR_MONTHS;
  };

  if (plan_type === 'std') {
    const weeklyMax = normalizeRateValue(selectedOffer?.std_weekly_max);

    let benefit = weeklyBenefit(member?.salary_amount, income_pct);

    if (benefit > weeklyMax) {
      benefit = weeklyMax;
    }

    if (rate_basis === 'earnings') {
      const monthlyCost = stdEarningsMonthly(member?.salary_amount, rate_per_unit, rateValue);
      return normalizeRateValue(monthlyCost, 2);
    }

    if (rate_basis === 'benefit') {
      const monthlyCost = stdBenefitMonthly(benefit, rate_per_unit, rateValue);
      return normalizeRateValue(monthlyCost, 2);
    }
  }

  if (plan_type === 'ltd') {
    const monthlyMax = selectedOffer?.ltd_monthly_max;

    let benefit = monthlyBenefit(member?.salary_amount, income_pct);

    if (benefit > monthlyMax) {
      benefit = monthlyMax;
    }

    if (rate_basis === 'earnings') {
      const monthlyCost = ltdEarningsMonthly(member?.salary_amount, rate_per_unit, rateValue);
      return normalizeRateValue(monthlyCost, 2);
    }

    if (rate_basis === 'benefit') {
      const monthlyCost = ltdBenefitMonthly(benefit, rate_per_unit, rateValue);
      return normalizeRateValue(monthlyCost, 2);
    }
  }

  return undefined;
};

const buildHouseholds = (householdFamilies, selectedOffer, resolveRate) => {
  let payload = {};

  for (const family_id in householdFamilies) {
    const household = householdFamilies[family_id];
    const householdPayload = [];

    for (const member of household) {
      if (member?.relationship === 'employee') {
        const rateValue = resolveRate(member, selectedOffer);
        const rate = computeMemberRate(member, selectedOffer, rateValue);

        householdPayload.push({ ...member, type: 'Employee', rate });
      } else {
        householdPayload.push(member);
      }
    }

    payload = { ...payload, [family_id]: householdPayload };
  }

  return payload;
};

const calculateEmployeeRate = (householdFamilies, selectedOffer) => {
  return buildHouseholds(householdFamilies, selectedOffer, (_, offer) => offer?.rate_ee);
};

const calculateEmployeeAgeRates = (householdFamilies, selectedOffer) => {
  return buildHouseholds(householdFamilies, selectedOffer, (member, offer) => {
    const memberAge = moment().diff(moment(member.date_of_birth), 'years');

    return offer[`age_${memberAge}`];
  });
};

export const calculateDisabilityRates = (accountMembers, selectedOffer) => {
  const householdFamilies = accountMembers.reduce((prev, current) => {
    if (typeof prev[current.family_id] === 'undefined') {
      prev[current.family_id] = [];
    }

    prev[current.family_id].push(current);

    return prev;
  }, {});

  const householdTierTypes = calculateEmployeeRate(householdFamilies, selectedOffer);

  let total = 0;
  let totalEmployer = 0;

  console.log('selectedOffer', selectedOffer);

  for (const family_id in householdTierTypes) {
    if (family_id !== 'total') {
      for (const member of householdTierTypes[family_id]) {
        total += member?.rate || 0;

        if (selectedOffer?.contribution_type === 'employer') {
          totalEmployer += member?.rate || 0;
        }
      }
    }
  }

  return {
    ...householdTierTypes,
    total: normalizeRateValue(total, 2),
    totalEmployer: normalizeRateValue(totalEmployer, 2),
  };
};

export const calculateDisabilityAgeRates = (accountMembers, selectedOffer) => {
  const householdFamilies = accountMembers.reduce((prev, current) => {
    if (typeof prev[current.family_id] === 'undefined') {
      prev[current.family_id] = [];
    }

    prev[current.family_id].push(current);

    return prev;
  }, {});

  const householdTierTypes = calculateEmployeeAgeRates(householdFamilies, selectedOffer);

  let total = 0;
  let totalEmployer = 0;

  for (const family_id in householdTierTypes) {
    if (family_id !== 'total') {
      for (const member of householdTierTypes[family_id]) {
        total += member?.rate || 0;

        if (selectedOffer?.contribution_type === 'employer') {
          totalEmployer += member?.rate || 0;
        }
      }
    }
  }

  return {
    ...householdTierTypes,
    total: normalizeRateValue(total, 2),
    totalEmployer: normalizeRateValue(totalEmployer, 2),
  };
};
